module.exports = __webpack_public_path__ + "static/media/UPE_logo.3f025a63.svg";